export default {
    data: () => ({
        service: {},
        item: {},
        lista: [],
        totalLista: 0,
        loading: false,
        dialogCadastro: false,
        search: '',
        options: {
            itemsPerPage: 15
        },
        include: ''
    }),
    watch: {
        options: {
          handler () {
            this.Listar(null, this.include);
          },
          deep: true
        }
      },
    methods: {
        Listar(filter, include){

            this.loading = true;
            const { sortBy, sortDesc, page, itemsPerPage } = this.options;

            this.service.Listar(page, itemsPerPage, sortBy, sortDesc, this.search, this.headers, filter, include)
                .then(
                    res => {
                        this.lista = res.data.items; 
                        this.totalLista = res.data.count;
                        this.loading = false;
                    },
                    err => {
                        this.$swal('Aviso', err.response.data, 'error');
                        this.loading = false;
                    }
                );
        },
        NovoCadastro(itemNovo){
            this.item = itemNovo;
            this.dialogCadastro = true;
        },
        EditarCadastro(itemNovo) {
            this.item = itemNovo;
            this.dialogCadastro = true;
        },
        Excluir(item) {
            this.$swal({
                title: 'Atenção!',
                text: 'Tem certeza que deseja excluir o registro atual?',
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                showCloseButton: true,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.service.Excluir(item.id).then(
                        res => {
                            if (res.status == 200){
                                return res;
                            }
                        }, 
                        err => this.$swal('Aviso', err.response.data, 'error')
                    )
                },
                allowOutsideClick: () => !this.$swal.isLoading()
                })
                .then((result) => {
                    if(result.value) {
                        this.$swal('Aviso', result.value.data, result.value.status == 200 ? 'success' : 'warning');
                        this.Listar(null, this.include);
                    }
                })
        }
    }
  };